import type { Menu } from 'src/modules/designStudio/constants';
import type { Mode } from 'src/modules/designStudio/providers';

enum Orientation {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}

enum UIKind {
  LANDSCAPE = 'LANDSCAPE',
  MOBILE = 'MOBILE',
}

interface UILayerProps {
  shouldDisplayToolbar: boolean;
  setMenu: (menu: Menu | null) => void;
  closeMenu: () => void;
  showDesignChanges: boolean;
  setCardHeight: (height: number) => void;
  menu: Menu | null;
  mode: Mode;
  loading: boolean;
  userId?: number;
  isOnline: boolean;
  jobId?: number;
  modelId?: number;
  requestingOrgName?: string;
  orientation?: Orientation;
  isSavedDesignsMenuOpen: boolean;
  onSavedDesignsMenuOpen: () => void;
  onSavedDesignsMenuClose: () => void;
}

export { Orientation, UIKind, UILayerProps };
